export enum BankingAdoptionTaskStatus {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
}

export interface BankingAdoption {
    id: string;
    userId: string;
    accountFundedStatus: BankingAdoptionTaskStatus;
    accountFundedUpdatedAt?: Date;
    billSwitchStatus: BankingAdoptionTaskStatus;
    billSwitchUpdatedAt?: Date;
    directDepositStatus: BankingAdoptionTaskStatus;
    directDepositUpdatedAt?: Date;
    completedAt?: Date;
}

export interface BankingAdoptionUpdateDto {
    accountFundedStatus?: BankingAdoptionTaskStatus;
    billSwitchStatus?: BankingAdoptionTaskStatus;
    directDepositStatus?: BankingAdoptionTaskStatus;

    // Not including UpdatedAt or completedAt fields here because the backend has the logic for
    // figuring that out.
}
